<template><div><h1 id="zahlungsarten" tabindex="-1"><a class="header-anchor" href="#zahlungsarten"><span>Zahlungsarten</span></a></h1>
<p>Zahlungsarten — Definiert die Zahlungsarten</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Diese Tabelle definiert die Zahlungsarten. Z.B. Barzahlungen, Kreditkarten, etc.</p>
<p>Pfad: <code v-pre>Buchhaltung → Tabellen → Zahlungsarten</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Zahlungsart</dt>
<dd>Zahlungsart</dd>
<dt>Beschreibung</dt>
<dd>Beschreibung der Zahlungsart</dd>
<dt>Typ</dt>
<dd>Typ</dd>
</dl>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.tblzahlungsverwendungen.html" title="Zahlungsverwendungen">Zahlungsverwendungen</RouteLink></p>
</div></template>


